import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cswhile() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };

  return (
    <div>
     <Sides/>

      <Helmet>

        <title>Learn Free PHP While Tutorials For Beginners CodeExampler</title>
        <meta name="description" content="Php While tutorial for beginners While in Php is a collection of similar type of data and stored in manually consecutively under one name" />
        <meta name="keywords" content="codeexampler,php while loop array,php while array,Php While,php while loop,Php While for loop,end for loop Php,exit while loop Php,While foreach Php,Php foreach While" />
        <link rel="canonical" href="https://www.codeexampler.com/php-while" />
      </Helmet>

      <div className='lg:pl-56'>

      <h1 className="m-4 mh1">Php while loop</h1>
      <div className="first">
        <a href="/php-looping-statement">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
        <a href="/php-do-while"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
      </div>
      <h2 className="mt-4 mh2">While loop for Php:</h2>
      <p className="mt-4 para">While loop will give this condition, and the loop's body Execute until the given condition is false and Check <a href="https://www.codeexampler.com/php-switch">Switch Case PHP</a> </p>
    


      <h2 className="headings">while loop Php syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">While</span>
              <span className="qwerty-7"> (</span>
              <span className="qwerty-3">condition</span>
            <span className="qwerty-7">)</span>
              {"\n"} 
              <span className="qwerty-4"> statement</span>
              {"\n"} 
              <span className="qwerty-2">  &#123;</span>
              {"\n"} 
              <span className="qwerty-10"> body</span>
              {"\n"} 
              <span className="qwerty-2"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="mt-4 mh2"> Php While loop Examples:</h2>

    
      <h2 className="headings">Q-Write a program Addition or increment while loop Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">while </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">."</span>
    
            <span className="qwerty-10">\</span>
            <span className="qwerty-3">n </span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">  OR</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">1 </span>
              {"\n"}
              <span className="qwerty-6">2 </span>
              {"\n"}
              <span className="qwerty-6">2 </span>
              {"\n"}
              <span className="qwerty-6">4 </span>
              {"\n"}
              <span className="qwerty-6">5 </span>
              {"\n"}
              <span className="qwerty-6">6 </span>
              {"\n"}
              <span className="qwerty-6">7 </span>
              {"\n"}
              <span className="qwerty-6">8 </span>
              {"\n"}
              <span className="qwerty-6">9 </span>
              {"\n"}
              <span className="qwerty-6">10 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

    

      <h2 className="headings">Q-Write a program Subtract or decrement in while loop Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">while </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">."</span>
            
            <span className="qwerty-10">\</span>
            <span className="qwerty-3">n </span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">  OR</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">- </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">10</span>
              {"\n"}
              <span className="qwerty-6">9 </span>
              {"\n"}
              <span className="qwerty-6">8 </span>
              {"\n"}
              <span className="qwerty-6">7</span>
              {"\n"}
              <span className="qwerty-6">6 </span>
              {"\n"}
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-6">4 </span>
              {"\n"}
              <span className="qwerty-6">3 </span>
              {"\n"}
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-6">1</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="mt-4 mh2">While loop uses logic operator in Php:</h2>
     


      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">While</span>
              <span className="qwerty-7"> (</span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-2"> &#60;</span>
              <span className="qwerty"> =</span>
              <span className="qwerty-4"> 10</span>
              <span className="qwerty-6"> && </span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-2"> &#62;</span>
              <span className="qwerty"> = </span>
              <span className="qwerty-4">1</span>
            <span className="qwerty-7">)</span>
              {"\n"} 
              <span className="qwerty-6">While</span>
              <span className="qwerty-7"> (</span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-2"> &#60;</span>
              <span className="qwerty"> =</span>
              <span className="qwerty-4"> 10</span>
              <span className="qwerty-6"> || </span>
              <span className="qwerty-3">a</span>
              <span className="qwerty-2"> &#62;</span>
              <span className="qwerty"> = </span>
              <span className="qwerty-4">1</span>
            <span className="qwerty-7">)</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="mt-4 mh2">While Loop Reverse Php:</h2>
     
      <h2 className="headings">Q-Write a program to input an integer number and print in reverse in Php Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-6">2560</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">while </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">% </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">/ </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-10">2560</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


  

      <h2 className="headings">Q-Write a program to input found out the sum of digits of integer no in Php Example?
</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">2560</span>
            <span className="qwerty-2">; </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-6">sum </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-9">0</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">while </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-9">0</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-6">sum</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-6">sum </span>
            <span className="qwerty-5">+ </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">/ </span>
            <span className="qwerty-9">10</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-2">("</span>
            <span className="qwerty-6">sum </span>
            <span className="qwerty-2">of </span>
            <span className="qwerty-6">Digits</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-2">".</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-6">sum</span>
            <span className="qwerty-2">); </span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">sum </span>
          <span className="qwerty-2">of</span>
            <span className="qwerty-6"> Digits</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-9">2844.4444444444 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/php-looping-statement"> <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
        <a href="/php-do-while"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
      </div>
      </div>
    </div>
  )

}
export default Cswhile;